import styles from './PostComposerWorkflow.module.css'

export default function ContentStep({ media, content, cta, showStepLabel = true }) {
  return (
    <section className={styles.step} aria-labelledby="post-composer-content-heading">
      <header className={styles.stepHeader}>
        {/* See PublishStep: one-page mode counts no steps. */}
        {showStepLabel ? <p className={styles.stepEyebrow}>Step 1 of 3</p> : null}
        <h2 id="post-composer-content-heading" tabIndex={-1}>Content</h2>
      </header>
      {media}
      {content}
      {cta}
    </section>
  )
}
